// Room chat over the reliable data channel (F-COM-1). In E2EE meetings the
// payload is sealed app-side before publish (sealed.ts, SPEC §5.2a) — LiveKit's
// worker covers media frames only, so the SFU would otherwise see chat in the
// clear. History is session-only by design: nothing here persists.

export const CHAT_TOPIC = 'bz.chat';
// Private 1:1 chat (F-COM-2): same wire, sent to a single destination
// identity, kept in a visually distinct thread — never leaks to the room.
export const PCHAT_TOPIC = 'bz.pchat';

export interface ChatMessage {
  id: string;
  fromIdentity: string;
  fromName: string;
  text: string;
  ts: number;
}

export interface ChatWire {
  v: 1;
  id: string;
  text: string;
  ts: number;
}

const encoder = new TextEncoder();
const decoder = new TextDecoder();

export function encodeChat(text: string): { payload: Uint8Array<ArrayBuffer>; wire: ChatWire } {
  const wire: ChatWire = { v: 1, id: randomId(), text, ts: Date.now() };
  return { payload: new Uint8Array(encoder.encode(JSON.stringify(wire))), wire };
}

export function decodeChat(payload: Uint8Array): ChatWire | null {
  try {
    const parsed = JSON.parse(decoder.decode(payload)) as ChatWire;
    if (parsed.v !== 1 || typeof parsed.text !== 'string' || parsed.text.length === 0) return null;
    // Bound message size defensively; rendering is escape-by-default (§9.2).
    if (parsed.text.length > 4000) parsed.text = parsed.text.slice(0, 4000);
    return parsed;
  } catch {
    return null;
  }
}

export function randomId(): string {
  const b = new Uint8Array(8);
  crypto.getRandomValues(b);
  return Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
}
